import React, {Component} from 'react';
import './Home_Page_Card_6.scss';
import Card from "@material-ui/core/Card";
import TemplatePagePlaceholder from "../../../template_page/template_page_placeholder/template_page_placeholder";
import ReactPlayer from "react-player";

class HomePageCard6 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: false,
            isHidden: false
        };
        this.notizieRef = React.createRef();
    }

    playVideo = () => {
        this.setState({
            isHidden: true,
            playing: true
        })
    };

    render() {
        let squareBackground = Object.assign({
            backgroundColor: "white",
        }, this.props.style);
        return <Card className="home-square not-selectable h-entry" style={squareBackground}
                     square={true}>
            <div className={'video-container'}>
                {this.props.content.image ? <TemplatePagePlaceholder
                    className={'player'} image={this.props.content.image}
                    video={this.props.content.video}/> :
                    <div className="card6-video">
                        <ReactPlayer className="card-video"
                                     url={this.props.content.video}
                                     ref={this.notizieRef}
                                     controls={!this.state.isHidden}
                                     playing={this.state.playing} muted/>
                        {!this.state.isHidden &&
                        <button className="card6-video-button" onClick={() => this.playVideo()}>
                            <div className="card6-video-button-shadow"/>
                            <div className="card6-triangle"/>
                        </button>
                        }
                    </div>}
            </div>
            {this.props.content.title ?
                <div className="card-title not-selectable">{this.props.content.title}</div> : null}
            {this.props.content.subtitle ?
                <div className="card-subtitle not-selectable">{this.props.content.subtitle}</div> : null}
            <div className={this.props.content.video ? 'clickable' : 'clickable-all'}
    onClick={this.props.onSquareSelected}/>
        </Card>;
    }
}

export default HomePageCard6;
